import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { portalThemeResolver } from './core/resolvers/portal-theme.resolver';

/**
 * Internal Portal route table.
 *
 * Authentication is handled by the Company SSO app — this SPA has no login UI.
 * Every route lives behind `authGuard` and renders inside the app shell.
 * Feature modules are scaffolded in subsequent phases.
 */
export const routes: Routes = [
  {
    path: '',
    resolve: { _theme: portalThemeResolver },
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES)
      },
      {
        path: 'consignors',
        loadChildren: () => import('./features/consignors/consignors.routes').then(m => m.CONSIGNORS_ROUTES)
      },
      {
        path: 'carts',
        loadChildren: () => import('./features/carts/carts.routes').then(m => m.CARTS_ROUTES)
      },
      {
        path: 'items',
        loadChildren: () => import('./features/items/items.routes').then(m => m.ITEMS_ROUTES)
      },
      {
        path: 'disputes',
        loadChildren: () => import('./features/disputes/disputes.routes').then(m => m.DISPUTES_ROUTES)
      },
      {
        path: 'payouts',
        loadChildren: () => import('./features/payouts/payouts.routes').then(m => m.PAYOUTS_ROUTES)
      },
      {
        path: 'tax',
        loadChildren: () => import('./features/tax-1099/tax.routes').then(m => m.TAX_ROUTES)
      },
      {
        path: 'rules',
        loadChildren: () => import('./features/rules/rules.routes').then(m => m.RULES_ROUTES)
      },
      {
        path: 'terms',
        loadChildren: () => import('./features/tc/tc.routes').then(m => m.TC_ROUTES)
      },
      {
        path: 'settings',
        loadChildren: () => import('./features/settings/settings.routes').then(m => m.SETTINGS_ROUTES)
      }
    ]
  },
  {
    path: '**',
    data: { hideShell: true },
    loadComponent: () =>
      import('./shared/components/not-found/not-found-page.component').then(m => m.NotFoundPageComponent)
  }
];
